import React from 'react'
import { useLocation } from 'wouter'

import { buildComponent } from '../../../../components/factory'
import { graphql } from '../../../../services/graphql'
import { serviceModals } from '../../../../services/modals'
import { Category } from '../../../../state/models/audio'
import { useStoreState } from '../../../../hooks/state'

import * as UI from '@mantine/core'
import * as Icons from '../../../../components/icons'

export const SectionDelete = buildComponent<{ categoryId: string }>()
  .withLifecycle(({ props }) => {
    const [, setLocation] = useLocation()
    const allCategories = useStoreState((store) => store.audio.categories)
    const category = allCategories.find(
      (c: Category) => c._id === props.categoryId,
    )

    const [deleting, setDeleting] = React.useState(false)

    const handleDelete = async () => {
      if (!category) {
        return
      }

      try {
        await serviceModals.confirmDeletion(
          'Supprimer la catégorie',
          `Voulez-vous vraiment supprimer la catégorie "${
            category.short?.fr || category.short?.en || category.slug
          }" ?`,
        )

        setDeleting(true)
        await graphql.mutations.deleteCategory(category._id)
        setLocation('/categories')
      } catch (err) {
        console.error('Erreur lors de la suppression:', err)
      } finally {
        setDeleting(false)
      }
    }

    return { category, handleDelete, deleting }
  })
  .withRender(({ lifecycle }) => (
    <UI.Stack spacing={24}>
      <UI.Text size="sm" color="dimmed">
        Une fois supprimée, cette catégorie ne pourra plus être récupérée.
        <br />
        Cette action est irréversible.
      </UI.Text>
      <UI.Button
        color="red"
        leftIcon={<Icons.FontAwesomeIcon icon={Icons.Solid.faTrash} />}
        loading={lifecycle.deleting}
        onClick={lifecycle.handleDelete}
        sx={{ alignSelf: 'flex-start' }}
      >
        Supprimer la catégorie
      </UI.Button>
    </UI.Stack>
  ))
